import { render } from "./HeadingV2.vue?vue&type=template&id=ff5ff354&ts=true"
import script from "./HeadingV2.vue?vue&type=script&lang=ts"
export * from "./HeadingV2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__